$(document).on('Searchanise.ResultsUpdated', () => {
    $(document).ready(() => {
        appendNoResultsMessage();
        updateCollectionTitle();
    });
});

$(document).ready(() => {
    initRedirect();
    initCustomerVehicleButton();
    

    const params = new URLSearchParams(window.location.search);
    if (params.has('open-widget')) {
        openOffcanvas();
    } else {
      initVehicleSelect();
    }
});


const metafield = {
    racing_planet: 'rb_filter_metafield_725ba553f080b9f1c1054e0d9eb224c1',
    parts_europe: 'rb_filter_metafield_ea1697340874ee35497e3137b1d05850',
};

let widgetLoaded = false;

function initRedirect() {
    if (!isCompatiblePartsPage()) return;

    if (window.location.href.includes(metafield.racing_planet) || window.location.href.includes(metafield.parts_europe)) return;

    const params = new URLSearchParams(window.location.search);
    if (params.has('open-widget')) return;

    const vehicle = getCustomerVehicleFromLocalStorage();

    if (!vehicle) return;

    location.href = getVehicleCollectionURL(vehicle);
}

function getVehicleCollectionURL(vehicle) {
    const locale = getLocalePrefix();
    const path = `${locale}/collections/compatible-parts`;
    return vehicle
        ? `${path}?${vehicle.vehicle_type === 'racing_planet' ? metafield.racing_planet : metafield.parts_europe}=${vehicle.vehicle_id}`
        : path;
}

function isCompatiblePartsPage() {
    return window.location.pathname.endsWith('/collections/compatible-parts');
}

function getLocalePrefix() {
    const match = window.location.pathname.match(/^\/(en|lt|et)(\/|$)/);
    return match ? `/${match[1]}` : '';
}


function initCustomerVehicleButton() {
    const vehicle = getCustomerVehicleFromLocalStorage();
    const buttons = document.querySelectorAll('.customer-vehicle');

    buttons.forEach(button => {
        button.onclick = () => {
            location.href = getVehicleCollectionURL(vehicle);
        };
    });
}


function getCustomerVehicleFromLocalStorage() {
    return JSON.parse(localStorage.getItem('selectedVehicle')) || null;
}

function createButton(text, onClick) {
    const button = document.createElement('a');
    button.href = "javascript:void(0)";
    button.textContent = text;
    button.classList.add('vehicle-action-bar-btn');
    button.onclick = onClick;
    return button;
}

function handleChangeVehicle() {
    const offcanvas = new bootstrap.Offcanvas(document.getElementById('offcanvasCustomerVehicleSelect'));
    offcanvas.show();
}

function handleCancelVehicle() {
    localStorage.removeItem('selectedVehicle');
    window.location.href = `${getLocalePrefix()}/collections/all`;
}

function updateCollectionTitle() {
    if (!isCompatiblePartsPage()) return;

    const vehicleData = getCustomerVehicleFromLocalStorage();
    const titleElement = document.querySelector('.snize-main-panel-collection-results-found');
    const existingActionBarElement = document.querySelector('.vehicle-action-bar');

    if (!vehicleData || !titleElement || existingActionBarElement) return;

    // Remove existing subtitle if present
    document.querySelector('.vehicle-action-bar')?.remove();

    // Create subtitle container
    const subtitleElement = document.createElement('div');
    subtitleElement.classList.add('vehicle-action-bar');

    // Create vehicle title span
    const vehicleTitle = document.createElement('span');
    vehicleTitle.classList.add('vehicle-bar-title');
    vehicleTitle.textContent = `${vehicleData.bike_producer} ${vehicleData.bike_model} ${vehicleData.sales_name ?? ''} ${vehicleData.year ?? ''}`.trim();

    // Create button container
    const buttonContainer = document.createElement('span');
    buttonContainer.classList.add('vehicle-action-bar-btn-container');
    buttonContainer.append(createButton('Mainīt', handleChangeVehicle), createButton('Atcelt', handleCancelVehicle));

    // Append elements
    subtitleElement.append(vehicleTitle, buttonContainer);
    titleElement.appendChild(subtitleElement);
}


function appendNoResultsMessage() {
    if (!isCompatiblePartsPage()) return;
    if (!isSingleSearchParam()) return;

    const noProductsCustomElement = document.querySelector('.snize-custom-no-results');
    if (noProductsCustomElement) return;

    const noProductsElement = document.querySelector('.snize-no-products-found');
    if (!noProductsElement) return;

    const resultsContainer = document.querySelector('#snize_results .snize-horizontal-wrapper .snize-horizontal-left');
    const mainContent = document.querySelector('.snize-main-panel');
    if (!resultsContainer && !mainContent) return;

    const newWrapper = document.createElement('div');
    newWrapper.classList.add('snize-custom-no-results');
    newWrapper.innerHTML = `
    <div class="snize-main-panel-collection-results-found" aria-live="polite">
        Piemērotās preces
    </div>
  `;



    if (window.innerWidth < 992) {
        if (mainContent) {
            mainContent.parentNode.insertBefore(newWrapper, mainContent);
        }
    } else {
        resultsContainer.appendChild(newWrapper);
    }
}


function isSingleSearchParam() {
    const params = new URLSearchParams(window.location.search);
    const allowedKeys = [
        "rb_filter_metafield_725ba553f080b9f1c1054e0d9eb224c1",
        "rb_filter_metafield_ea1697340874ee35497e3137b1d05850"
    ];
    const paramKeys = Array.from(params.keys());
    return paramKeys.length === 1 && allowedKeys.includes(paramKeys[0]);
}

const initVehicleSelect = function () {
    if (!isCompatiblePartsPage()) return;

    const vehicleData = getCustomerVehicleFromLocalStorage();
    if (!vehicleData) {
        openOffcanvas();
    }
};

function vehicleSelectCallback(vehicle) {
    location.href = getVehicleCollectionURL(vehicle);
}

function openOffcanvas() {
    const offcanvasElement = document.getElementById('offcanvasCustomerVehicleSelect');
    const closeButton = offcanvasElement.querySelector('.close-offcanvas-btn');

    // Check if a vehicle is stored in localStorage
    const vehicle = getCustomerVehicleFromLocalStorage();

    if (!vehicle) {
        offcanvasElement.setAttribute('data-bs-backdrop', 'static'); // Make static
        if (closeButton) closeButton.style.display = 'none'; // Hide close button
    } else {
        offcanvasElement.removeAttribute('data-bs-backdrop'); // Allow dismissal
        if (closeButton) closeButton.style.display = 'block'; // Show close button
    }

    new bootstrap.Offcanvas(offcanvasElement).show();
}

$('#offcanvasCustomerVehicleSelect').on('show.bs.offcanvas', function () {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    if (!widgetLoaded) {
        widgetLoaded = true;

        // Get "tab" from URL
        const params = new URLSearchParams(window.location.search);
        const tab = params.get('tab');
        const validTabs = ['1', '2'];

        // Pass tab as 3rd param if valid
        const defaultTab = validTabs.includes(tab) ? Number(tab) : undefined;

        window.vehicleWidget('#customerVehicleSelect', vehicleSelectCallback, defaultTab);
    }
});


$('#offcanvasCustomerVehicleSelect').on('hidden.bs.offcanvas', () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
});
